const NYC_TIMEZONE = 'America/New_York';

/**
 * Get the current hour (0-23) in New York City local time.
 */
export function getNYCHour() {
  const nycTime = new Date().toLocaleString('en-US', { timeZone: NYC_TIMEZONE });
  return new Date(nycTime).getHours();
}

/**
 * Whether it's "night" in NYC: between 6pm (18:00) and 6am (06:00).
 * Used for weather icon (e.g. clear sky -> moon at night).
 */
export function isNightInNYC() {
  const hour = getNYCHour();
  return hour >= 18 || hour < 6;
}
